/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostJssFormInput = {|
  attachments?: ?$ReadOnlyArray<?any>,
  brandIds: $ReadOnlyArray<?string>,
  comments?: ?string,
  conversion?: ?string,
  name: string,
  phone: string,
  quoteNumber: string,
  quoteValue: number,
  storeId: string,
|};
export type PostJssFormMutationVariables = {|
  input: PostJssFormInput
|};
export type PostJssFormMutationResponse = {|
  +postJssForm: ?{|
    +result: ?boolean
  |}
|};
export type PostJssFormMutation = {|
  variables: PostJssFormMutationVariables,
  response: PostJssFormMutationResponse,
|};
*/


/*
mutation PostJssFormMutation(
  $input: PostJssFormInput!
) {
  postJssForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostJssFormPayload",
    "kind": "LinkedField",
    "name": "postJssForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostJssFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostJssFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2fdc0f2257eaef768715b997d7c510e6",
    "id": null,
    "metadata": {},
    "name": "PostJssFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostJssFormMutation(\n  $input: PostJssFormInput!\n) {\n  postJssForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e18cee894341caeb407f4b39e0716dc';

module.exports = node;
